import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import {
  connectWebSocket,
  listenToEvent,
  disconnectWebSocket,
} from "../payment/webSocketService";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import razorpayicon from "../../assets/mon.png";
import { AnimatePresence, motion } from "framer-motion";
import { getStaticPricing,getStaticPricingBundle } from "../../utils/pricingConfig";
import ebook1 from "../../assets/ebook1.jpg";
import ebook2 from "../../assets/ebook2.jpg";
import { Theme } from "../../lib/theme.ts";
import { useSelector } from 'react-redux';
import { selectIsEligibleForDownload } from '../../redux/slices/pptSlice';
import MontyPayCheckout from "../payment/MontyPayCheckout.tsx";

interface PricingModalNewProps {
  closeModal: () => void;
  currency: string;
  exportButtonText: string;
  exportButtonBundleText: string;
  exportHandler: (isSingleExport?: boolean) => void;
  setIsBundle: React.Dispatch<React.SetStateAction<boolean>>;
  savings?:string;
  notNew?:boolean
}
const testimonials = [
  {
    message:
      "Zynth helped us save hours on presentation content and design. The exports are clean and investor-friendly.",
    name: "Anuj, Co-founder, Skale",
  },
  {
    message: "Used Zynth for my YC deck - clean, fast, and totally worth it.",
    name: "Priya, Founder, CleanCart",
  },
  {
    message:
      "The tool delivers excellent output, creating a well-structured and visually appealing pitch deck.",
    name: "Anthony Crosato",
  },
  {
    message:
      "The pitch deck created through Zynth app is excellent, providing a clear and professional presentation of our ideas.",
    name: "Hitesh Mittal, Founder, Hitech Enviro",
  },
];

export const PricingModalNew: React.FC<PricingModalNewProps> = ({
  closeModal,
  currency,
  exportButtonText,
  exportButtonBundleText,
  exportHandler,
  setIsBundle,
  savings,
  notNew
}) => {
  const userEmail = sessionStorage.getItem("userEmail");
  const userName = sessionStorage.getItem("userName") || userEmail?.split('@')[0] || "User";
  const orgId = sessionStorage.getItem("orgId");
  const authToken = sessionStorage.getItem("authToken");
  // const displayCurrency = currency === "INR" ? "INR" : "USD";
  const displayCurrency = "USD";
  const pricing = getStaticPricing(displayCurrency);
  const getBundlePricing = getStaticPricingBundle(displayCurrency);
  const [currentIndex, setCurrentIndex] = useState(0);
  const isEligibleForDownload = useSelector(selectIsEligibleForDownload);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [starterPackagePrice, setStarterPackagePrice] = useState(299);
  const [hasReferralDiscount, setHasReferralDiscount] = useState(false);
  const [referralCodeUsed, setReferralCodeUsed] = useState<string | null>(null);

  // Fetch organization profile to check for referral code TSV007
  useEffect(() => {
    const fetchReferralDiscount = async () => {
      if (!orgId || !authToken) return;
      
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        
        // Support multiple referral codes and fallback keys
        const rawCode = response.data.referralCode || response.data.referral_code || response.data.referral?.code;
        const referralCode = rawCode ? String(rawCode).trim().toUpperCase() : null;
        // Map of referral codes to discounted prices
        const referralMap: Record<string, number> = {
          TSV007: 99,
          LLB150: 150,
          EONO50: 50,
        };

        if (referralCode && referralMap[referralCode]) {
          const discounted = referralMap[referralCode];
          setStarterPackagePrice(discounted);
          setHasReferralDiscount(true);
          setReferralCodeUsed(referralCode);
          console.log(`${referralCode} referral discount applied: $299 -> $${discounted}`);
        }
      } catch (error) {
        console.error("Error fetching organization profile for referral check:", error);
      }
    };

    fetchReferralDiscount();
  }, [orgId, authToken]);

  useEffect(() => {
    const interval = setInterval(() => {
      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * testimonials.length);
      } while (newIndex === currentIndex);
      setCurrentIndex(newIndex);
    }, 3000);

    return () => clearInterval(interval);
  }, [currentIndex]);
  return (
    <div
      className={`${
        ![
          "/presentation-view",
          "/new-presentation",
          "/organization-profile",
          "/history",
          "/edit-organization-profile",
          "/refer",
        ].includes(window.location.pathname) &&
        !window.location.href.includes("/presentation-view?") &&
        !window.location.href.includes("#/history") &&
        !window.location.href.includes("#/refer") &&
        !window.location.href.includes("#/new-presentation") &&
        !window.location.href.includes("#/organization-profile") &&
        !window.location.href.includes("#/edit-organization-profile")
          ? "fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center"
          : "fixed top-0 left-0 w-screen h-screen z-50 bg-gray-800 bg-opacity-50 flex justify-center items-center"
      }`}
    >
      

      <div className="bg-white w-[95%] lg:w-[92%] xl:w-[70%] max-h-[95%] md:max-h-[100%] lg:max-h-[98%] overflow-y-auto scrollbar-none rounded-lg shadow-lg p-4 sm:p-6 relative mx-auto">
        <button
          onClick={closeModal}
          className="absolute top-2 right-2 sm:top-4 sm:right-4 text-gray-500 hover:text-gray-900 hover:scale-110 active:scale-95 transform transition text-lg md:text-4xl"
        >
          &times;
        </button>

        <div className="text-center">
          <p className="font-semibold text-2xl sm:text-3xl">
          { isEligibleForDownload?"Need to generate more pitch decks?":`Join now for $${starterPackagePrice}. One-time payment`}
            {/* <span className="text-blue-700">READY TO GO</span> */}
          </p>
          {hasReferralDiscount && !isEligibleForDownload && referralCodeUsed && (
            <p className="text-green-600 font-semibold text-lg mt-1">
              🎉 Special {referralCodeUsed} Discount Applied! (Now ${starterPackagePrice})
            </p>
          )}
          <p className="text-base mt-2 sm:text-lg">
          { isEligibleForDownload?"Generate investor-ready pitch decks completely compatible with Google Slides and Powerpoint without spending time in writing content and designing slides.":" Are you ready to turn your great idea into a successful business? You will find all the necessary resources, from idea generation to funding."}
          </p>
        </div>
      {
        isEligibleForDownload?
        (
          <>

          <div className="flex flex-col md:flex-row w-full items-center justify-center gap-8 lg:gap-5 mt-4">
          <div className="relative  w-full sm:w-[90%] md:w-[80%] lg:w-[48%] min-h-[300px] xl:min-h-[300px] rounded-3xl"
            style={{
   background: `linear-gradient(
        to bottom,
        ${Theme.colors.gradient.primary1},
        ${Theme.colors.gradient.secondary1}
      )`,

  borderColor: Theme.colors.primary,
  textDecoration: 'none',
}}
          >
            <div className="absolute w-full h-full py-4 px-4">
              <button className="flex rounded-xl items-center justify-center bg-[#F5F9FF] w-[60%] sm:w-[40%] md:w-[50%]">
                <span className="text-black text-base sm:text-lg font-semibold">
                  SINGLE PITCH DECK
                </span>
              </button>
              <div className="mt-3 text-white">
                <p className="text-lg font-semibold text-black">Investor-Ready Pitch Deck</p>
                <p className="text-3xl sm:text-4xl font-semibold font-sans text-black">
                  {displayCurrency === "USD" ? `$${pricing.original}` : pricing.original} / Deck

                </p>
              </div>
              <hr className="border-t-2 border-dashed border-[#FFFFFF42] my-3 w-full" />

            
              <div className="flex flex-col gap-2">
                {/* For large screens – group into rows */}
                <div className="hidden lg:flex flex-col gap-4">
                  {[
                    ["Editable Google Slide", "Lifetime Access"],
                    ["Print-Ready PDF", "Immediate Download"],
                    ["Custom Branding & Layout"],
                  ].map((row, rowIndex) => (
                    <div
                      key={rowIndex}
                      className={`flex flex-wrap ${rowIndex===1?'gap-16':'gap-7'} items-center`}
                    >
                      {row.map((text, i) => (
                        <div key={i} className={`flex items-center  ${
                          rowIndex === 1 && i === 1 ? 'gap-2' : 'gap-2'
                        }`}>
                          <button className="rounded-full flex bg-white w-5 h-5 items-center justify-center">
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              className="text-blue-600 w-4 h-4"
                            />
                          </button>
                          <p className="text-black text-base font-semibold">
                            {text}
                          </p>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>

                <div className="flex flex-col gap-1 lg:hidden">
                  {[
                    "Editable Google Slide",
                    "Lifetime Access",
                    "Print-Ready PDF",
                    "Immediate Download",
                    "Custom Branding & Layout",
                  ].map((text, i) => (
                    <div key={i} className="flex items-center gap-2">
                      <button className="rounded-full flex bg-white w-5 h-5 items-center justify-center">
                        <FontAwesomeIcon
                          icon={faArrowRight}
                          className="text-blue-600 w-4 h-4"
                        />
                      </button>
                      <p className="text-white text-base font-semibold">
                        {text}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="absolute left-1/2 bottom-[-24px] transform -translate-x-1/2">
              <MontyPayCheckout
                amount={typeof pricing.original === 'number' ? pricing.original : parseFloat(pricing.original)}
                currency={displayCurrency}
                description="Single Pitch Deck"
                metadata={{
                  type: "single",
                  quantity: 1,
                  userEmail: userEmail,
                }}
                customerName={userName}
                customerEmail={userEmail || ""}
                onSuccess={() => {
                  setPaymentLoading(true);
                  setIsBundle(false);
                  // exportHandler(true);
                }}
                onError={(error) => {
                  console.error("Payment error:", error);
                  setPaymentLoading(false);
                }}
                buttonText={paymentLoading ? "Processing..." : "Get Pitch Deck"}
                buttonClassName="bg-[#3667B2] text-white font-semibold px-6 py-2 rounded-full shadow-md"
              />
            </div>
          </div>

          <div className="relative bg-[#F5F9FF] w-full sm:w-[90%] md:w-[80%] lg:w-[45%] min-h-[300px] xl:min-h-[300px] border border-gray-700 rounded-3xl">
            <div className="absolute w-full h-full py-4 px-4">
              <button className="flex rounded-xl items-center justify-center bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-[70%] sm:w-[60%] md:w-[80%] lg:w-[70%]">
                <span className="text-white text-base sm:text-lg font-semibold">
                  BUNDLE (POPULAR CHOICE)
                </span>
              </button>
              <div className="mt-3">
                <p className="text-black text-lg font-semibold">
                  Best Value: 3 Pitch Decks for
                </p>
                <p className="text-black text-3xl sm:text-4xl font-semibold font-sans">
                 {displayCurrency === "USD" ? `$${getBundlePricing.original}` : getBundlePricing.original} 

                </p>
              </div>
              <hr className="border-t-2 border-dashed border-[#49699987] my-3 w-full" />
              <div className="flex flex-col justify-center gap-3">
                {/* <div className="flex items-center gap-2">
                  <button className="rounded-full flex bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-5 h-5 items-center justify-center">
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-white w-4 h-4"
                    />
                  </button>
                  <p className="text-black text-base font-semibold">
                    Save {savings}
                  </p>
                </div> */}
                <div className="flex items-center gap-2">
                  <button className="rounded-full flex bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-5 h-5 items-center justify-center">
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-white w-4 h-4"
                    />
                  </button>
                  <p className="text-black text-base font-semibold">
                    Perfect for multiple versions or different Presentations
                  </p>
                </div>
              </div>
            </div>
            <div className="absolute left-1/2 bottom-[-24px] transform -translate-x-1/2">
              <MontyPayCheckout
                amount={typeof getBundlePricing.original === 'number' ? getBundlePricing.original : parseFloat(getBundlePricing.original)}
                currency={displayCurrency}
                description="Bundle - 3 Pitch Decks"
                metadata={{
                  type: "bundle",
                  quantity: 3,
                  userEmail: userEmail,
                }}
                customerName={userName}
                customerEmail={userEmail || ""}
                onSuccess={() => {
                  setPaymentLoading(true);
                  setIsBundle(true);
                  sessionStorage.setItem('isBundlePurchase', 'true');
                }}
                onError={(error) => {
                  console.error("Payment error:", error);
                  setPaymentLoading(false);
                }}
                buttonText={paymentLoading ? "Processing..." : "Get the Bundle"}
                buttonClassName="bg-white text-blue-700 font-semibold px-6 py-2 rounded-full shadow-md hover:border-2 hover:border-blue-700"
              />
            </div>
          </div>
        </div>



          </>
        ):(
          <>
           <div className="flex flex-col md:flex-row w-full items-center justify-center gap-8 lg:gap-5 mt-4">
         

          <div className="relative bg-[#F5F9FF] w-full sm:w-[90%] md:w-[50%] lg:w-[45%] min-h-[320px] xl:min-h-[320px] border border-gray-700 rounded-3xl"
        style={{
   background: `linear-gradient(
        to bottom,
        ${Theme.colors.gradient.primary1},
        ${Theme.colors.gradient.secondary1}
      )`,

  borderColor: Theme.colors.primary,
  textDecoration: 'none',
}}

            >
            <div className="absolute w-full h-full py-4 px-4">
              {/* <button className="flex rounded-xl items-center justify-center bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-[70%] sm:w-[60%] md:w-[80%] lg:w-[70%]">
                <span className="text-white text-base sm:text-lg font-semibold">
                  BUNDLE (POPULAR CHOICE)
                </span>
              </button> */}
              <div className="mt-3">
                <p className="text-black text-lg font-semibold">
                  {/* Best Value: 3 Exports for {exportButtonBundleText} */}
                  What's Included?
                </p>
                {/* <p className="text-black text-3xl sm:text-4xl font-semibold font-sans">
                  {exportButtonBundleText}
                </p> */}
              </div>
              <hr className="border-t-2 border-dashed border-[#49699987] my-3 w-full" />
              <div className="flex flex-col justify-center gap-3">
                <div className="flex items-center gap-2">
                  <button className="rounded-full flex bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-5 h-5 items-center justify-center">
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-white w-4 h-4"
                    />
                  </button>
                  <p className="text-black text-base font-semibold">
                    The Orca Blueprint
                  </p>
                </div>
            

                <div className="flex items-center gap-2">
                  <button className="rounded-full flex bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-5 h-5 items-center justify-center">
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-white w-4 h-4"
                    />
                  </button>
                  <p className="text-black text-base font-semibold">
                    AI Pitch Deck Generator
                  </p>
                </div>


                <div className="flex items-center gap-2">
                  <button className="rounded-full flex bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-5 h-5 items-center justify-center">
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-white w-4 h-4"
                    />
                  </button>
                  <p className="text-black text-base font-semibold">
                   Professional Pitch Evaluation
                  </p>
                </div>


                <div className="flex items-center gap-2">
                  <button className="rounded-full flex bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-5 h-5 items-center justify-center">
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-white w-4 h-4"
                    />
                  </button>
                  <p className="text-black text-base font-semibold">
                  Investor Scouting Portal
                  </p>
                </div>



                <div className="flex items-center gap-2">
                  <button className="rounded-full flex bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-5 h-5 items-center justify-center">
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-white w-4 h-4"
                    />
                  </button>
                  <p className="text-black text-base font-semibold">
                  Annual Funding Opportunity
                  </p>
                </div>
              </div>
            </div>
            <div className="absolute left-1/2 bottom-[-24px] transform -translate-x-1/2">
              <MontyPayCheckout
                amount={starterPackagePrice}
                currency="USD"
                description="OrcasValley Founder Accelerator full access"
                metadata={{
                  type: "starter_package",
                  includes: "Orca Blueprint, AI Pitch Deck Generator, Pitch Evaluation, Investor Portal, Funding Opportunity",
                  userEmail: userEmail,
                  referralDiscount: referralCodeUsed || undefined,
                }}
                customerName={userName}
                customerEmail={userEmail || ""}
                onSuccess={() => {
                  setPaymentLoading(true);
                  setIsBundle(true);
                  sessionStorage.setItem('isBundlePurchase', 'true');
                  
                  // Show info toast that payment window is open
                  // toast.info('Please complete your payment in the new tab', {
                  //   position: 'top-center',
                  //   autoClose: 3000,
                  // });
                }}
                onError={(error) => {
                  console.error("Payment error:", error);
                  setPaymentLoading(false);
                }}
                buttonText={paymentLoading ? "Processing..." : "Get Started"}
                buttonClassName="bg-white text-blue-700 font-semibold px-6 py-2 rounded-full shadow-md hover:border-2 hover:border-blue-700"
              />
            </div>
          </div>

          <div className="w-full md:w-1/2 flex justify-center lg:justify-center">
              <div className="w-[85%] sm:w-[80%] md:w-[85%] lg:w-[75%] xl:w-[70%] flex">
              <div
            className="flex-1 aspect-[2/3] sm:aspect-[3/5] md:aspect-[3/5] lg:aspect-[2/4] xl:aspect-[2/4] w-[50%] bg-white rounded-md"
            style={{
             backgroundImage: `url(${ebook1})`,
             backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
            backgroundPosition: "center right",
            }}
           ></div>

          <div
              className="flex-1 aspect-[2/3] sm:aspect-[3/5] md:aspect-[3/5] lg:aspect-[2/4] xl:aspect-[2/4] w-[50%] -ml-1 mt-12 sm:mt-16 md:mt-20 lg:mt-24 xl:mt-28 rounded-md"
            style={{
              backgroundImage: `url(${ebook2})`,
              backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center left",
              }}
               >
          </div>
         </div>
</div>
                      
        </div>
          </>
        )
      }
       

        {/* <div className="flex items-center justify-center mt-10">
          <div className="flex flex-col w-full sm:w-[90%] md:w-[70%] lg:w-[70%] xl:w-[60%] items-center justify-center border border-gray-500 rounded-xl px-4 py-4 ">
            <p
              className="text-lg italic text-gray-800 mb-2 text-center "
              style={{
                willChange: "opacity, transform, filter",
                backfaceVisibility: "hidden",
                perspective: "1000px",
              }}
            >
              "{message}"
            </p>
            <p
              className="text-sm font-semibold text-blue-700 self-start"
              style={{
                willChange: "opacity, transform, filter",
                backfaceVisibility: "hidden",
                perspective: "1000px",
              }}
            >
              - {name}
            </p>
            <div className="flex items-center mt-2 justify-start gap-2 w-full">
              {[...Array(5)].map((_, i) => (
                <FontAwesomeIcon
                  key={i}
                  icon={faStar}
                  className="text-yellow-400 w-5 h-5"
                />
              ))}
            </div>
          </div>
        </div> */}

        <hr className="border-t-2 border-dashed border-[#49699987]  mt-9 mb-3 w-full" />

        <div className="flex items-center justify-center gap-2">
          <p className="font-semibold text-lg sm:text-xl">
            Secure payments via
          </p>
          <img src={razorpayicon} alt="icon" className="h-8 w-auto" />
        </div>
      </div>
    </div>
  );
};